
export class NotificationRole {
  public notificationRoleID: number;
  public notificationID: number;
  public roleID: number;
  public action: string;
  public isAction: boolean;
}

export class PopupNotification{
  public id: string;
  public popupNotificationID: number;
  public title: string;
  public isActive: boolean;
  public startDate: string;
  public endDate: string;
  public createdDate: Date;
  public backGroundImage: string;
  public popupNotificationDetail: string; 
  public popupNotificaCss: string;
  public sortOrder: number;
  public userId: number;
  public targetUrl: string;
}



// WEBPACK FOOTER //
// ./src/app/models/notification/notificationRole.model.ts